export const EMPTY_FORM = {
  intPropertyID: "",
  intHotelRoomID: "",
  bitBreakfastIncluded: false,
  BreakfastCharge: "",
  dtmEffectiveFrom: new Date().toISOString().slice(0, 10),
  bitStatus: true,
};

export const DEFAULT_FILTERS = {
  propertyId: "",
  status: "",
  search: "",
};

export const toDateInput = (value) =>
  value ? String(value).slice(0, 10) : "";

export const formatDate = (value) =>
  value ? new Date(value).toLocaleDateString("en-IN") : "—";

export const getErrorMessage = (error, fallback) =>
  error.response?.data?.message || fallback;